import type { RunDetailResponse } from "contracts/api/crawl/run-read.responses";
import { For, Show } from "solid-js";
import { YEET_FAILURE_REASON_LABELS } from "../../enums/run-failures";
import { failureSeverityClass, groupFailuresByReason } from "./runPresentation";

/**
 * Failed pages rolled up by reason. Replaces the per-page wall of collapsed
 * technical detail: the reason and its page count are the headline, the
 * individual URLs and worker output sit underneath.
 */
export function RunFailureSummary(props: {
  pages: RunDetailResponse["pages"];
}) {
  const groups = () => groupFailuresByReason(props.pages);

  return (
    <Show when={groups().length > 0}>
      <section class="run-failure-summary">
        <h3>What went wrong</h3>
        <For each={groups()}>
          {(group) => (
            <details class="run-failure-group">
              <summary>
                <span class={`badge ${failureSeverityClass(group.reason)}`}>
                  {group.label}
                </span>
                <span>
                  {group.pages.length}{" "}
                  {group.pages.length === 1 ? "page" : "pages"}
                </span>
              </summary>
              <ul class="run-failure-pages">
                <For each={group.pages}>
                  {(page) => (
                    <li>
                      <span class="mono">{page.url}</span>
                      <Show when={page.attemptFailureReason}>
                        {(reason) => (
                          <small>{YEET_FAILURE_REASON_LABELS[reason()]}</small>
                        )}
                      </Show>
                      <Show when={page.httpStatus}>
                        {(status) => (
                          <small class="mono">HTTP {status()}</small>
                        )}
                      </Show>
                      <Show when={page.lastError}>
                        {(error) => <pre class="mono">{error()}</pre>}
                      </Show>
                    </li>
                  )}
                </For>
              </ul>
            </details>
          )}
        </For>
      </section>
    </Show>
  );
}
